import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50/50 to-white">
      {/* Header */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-br from-pink-100 to-rose-100 py-16"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", delay: 0.2 }}
            className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-6"
          >
            <FileText className="text-pink-500" size={32} />
          </motion.div>
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" 
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Terms of Service
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-lg text-gray-600 italic"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Please read these terms carefully
          </motion.p>
        </div>
      </motion.div>

      {/* Content */}
      <motion.div 
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
        className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
      >
        <motion.div variants={fadeInUp} className="prose prose-pink max-w-none">
          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
            <p className="text-gray-600 leading-relaxed">
              By accessing and using The Pink Edit website, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our website. We reserve the right to 
              modify these terms at any time, and your continued use of the site constitutes acceptance 
              of any changes.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Use of Website</h2>
            <p className="text-gray-600 leading-relaxed">
              You may use our website for lawful purposes only. You agree not to use the site in any way 
              that could damage, disable, or impair the site or interfere with any other party's use. 
              You may not attempt to gain unauthorized access to any part of the website or any systems 
              or networks connected to the site.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Product Information</h2>
            <p className="text-gray-600 leading-relaxed">
              We strive to display our products as accurately as possible. However, we cannot guarantee 
              that your monitor's display of any color will be accurate. We reserve the right to limit 
              quantities of any products and to discontinue any product at any time. Prices are subject 
              to change without notice.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
            <p className="text-gray-600 leading-relaxed">
              All content on this website, including text, graphics, logos, images, and software, is the 
              property of The Pink Edit and is protected by copyright and trademark laws. You may not 
              reproduce, distribute, or create derivative works from any content without our express 
              written permission.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact</h2>
            <p className="text-gray-600 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at thepinkedit@yahoo.com.
            </p>
          </motion.section>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default TermsOfServicePage;
